import React, { forwardRef, useEffect, useState } from "react";
import { bool, func, oneOf, string } from "prop-types";

import componentSizes from "../../../../constants/componentSizes";
import { TextInput } from "../../../TextField";
import { DEFAULT_COUNTRY, PHONE_NUMBER_FIELD_SIZES } from "../../constants";
import formatPhoneNumber from "../../utilties/formatPhoneNumber";
import getSuffix from "../../utilties/getSuffix";
import normalizePhoneNumber from "../../utilties/normalizePhoneNumber";

const PhoneNumberInput = forwardRef(
  ({ country, isValid, onChange, size, value, ...passThroughProps }, ref) => {
    const [phoneNumberVal, setPhoneNumberVal] = useState(
      formatPhoneNumber(country, value)
    );

    useEffect(() => {
      setPhoneNumberVal(formatPhoneNumber(country, value));
    }, [country, value]);

    const handleChange = event => {
      const { value: nextValue } = event.target;

      const formattedPhoneNumber = formatPhoneNumber(country, nextValue);
      const normalizedPhoneNumber = normalizePhoneNumber(nextValue);
      const suffix = getSuffix(normalizedPhoneNumber);

      setPhoneNumberVal(formattedPhoneNumber);

      onChange(event, normalizedPhoneNumber, {
        formattedPhoneNumber,
        suffix
      });
    };

    return (
      <TextInput
        ref={ref}
        isValid={isValid}
        onChange={handleChange}
        size={size}
        type="tel"
        value={phoneNumberVal}
        {...passThroughProps}
      />
    );
  }
);

PhoneNumberInput.displayName = "PhoneNumberInput";

PhoneNumberInput.propTypes = {
  country: string,
  isValid: bool,
  onChange: func,
  size: oneOf(PHONE_NUMBER_FIELD_SIZES),
  value: string
};

PhoneNumberInput.defaultProps = {
  country: DEFAULT_COUNTRY,
  isValid: true,
  onChange: () => {},
  size: componentSizes.MD,
  value: ""
};

export default PhoneNumberInput;
